import React, { useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { base_url } from "../utils/axiosConfig";
import axios from 'axios';
import toast from 'react-hot-toast';

const Resetpassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false); // 🔄 loading state
  const { token } = useParams();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (password !== confirmPassword) {
    toast.error('Passwords do not match.');
    return;
  }

  setLoading(true);

  try {
    await axios.put(`${base_url}user/reset-password/${token}`, { password });
    toast.success('Password reset successfully! Redirecting to login in 5 seconds...');

    setPassword('');
    setConfirmPassword('');
    formRef.current?.reset();

    let countdown = 5;
    const interval = setInterval(() => {
      countdown -= 1;
      if (countdown > 0) {
        toast.dismiss(); // remove old toast
        toast.info(`Redirecting to login in ${countdown} seconds...`);
      }
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      setLoading(false);
      navigate('/login');
    }, 5000); // ⏳ 5-second delay before redirect
  } catch (err) {
    setLoading(false);
    toast.error(err.response?.data?.message || 'Failed to reset password. The link may have expired.');
  }
};



  return (
    <div className="container py-3 position-relative">
      {loading && (
        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75 z-3">
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="card shadow-sm border-1">
            <div className="card-body p-4">
              <h3 className="card-title text-center mb-4">Reset Password</h3>

              <form ref={formRef} onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="Enter new password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="d-grid">
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                        Redirecting...
                      </>
                    ) : (
                      'Reset Password'
                    )}
                  </button>
                </div>
              </form>

              <div className="text-center mt-3">
                <small className="text-muted">Make sure to choose a strong password.</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resetpassword;
